import Reveal from "@/components/common/Reveal";
import Button from "@/components/common/Button";
import { ArrowRight } from "@/components/common/icons";
import { env } from "@/lib/env";
import { useLocale } from "@/i18n/useLocale";
import { chromeFor } from "@/content/chrome";
import { landingClosingFor } from "@/content/landing";
import { pathFor } from "@/routes/manifest";

export default function ClosingCTA(): JSX.Element {
  const locale = useLocale();
  const t = landingClosingFor(locale);
  const chrome = chromeFor(locale);

  return (
    <section className="section-y-lg">
      <div className="container-page">
        <Reveal>
          <div
            className="glass-card glass-card-glow flex flex-col gap-6 md:flex-row md:items-center md:justify-between md:gap-10 p-8 md:p-12 lg:p-16"
            style={{
              background:
                "radial-gradient(ellipse at 80% 50%, rgb(var(--brand) / 0.18), transparent 60%), linear-gradient(180deg, rgb(var(--fg) / 0.04) 0%, rgb(var(--fg) / 0.01) 100%)",
            }}
          >
            <div>
              <h3
                className="font-display leading-[1.05]"
                style={{ fontSize: "clamp(28px, 3.2vw, 44px)", letterSpacing: "-0.03em" }}
              >
                {t.headlineLead}
                <span className="text-brand-gradient">{t.headlineHighlight}</span>
              </h3>
              <p className="text-fg-muted mt-3.5 text-base max-w-[480px]">
                {t.body}
              </p>
            </div>
            <div className="flex gap-3 flex-wrap shrink-0">
              <Button size="lg" variant="primary" href={env.registerUrl}>
                {chrome.cta.getFunded} <ArrowRight />
              </Button>
              <Button size="lg" variant="ghost" href={pathFor("/how-it-works", locale)}>
                {t.ctaSecondary}
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
